import React from 'react';
import { Grid, Typography } from '@material-ui/core';

export default function KnowledgeBase() {
  return (
    <>
      <Grid item xs={12}>
        <Typography component="h2" variant="h6" gutterBottom>
          Knowledge Base
        </Typography>
        <p>Coming soon!</p>
      </Grid>
    </>
  );
}
